var _circle, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideBar3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1934,
    cy: 16.6304,
    r: 15.7715,
    fill: "#C3A6F1",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.70479,
    y: 9.50167,
    width: 4.41548,
    height: 4.41569,
    rx: 0.503993,
    stroke: "#914DE5",
    strokeWidth: 0.815835
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.70479,
    y: 19.344,
    width: 4.41548,
    height: 4.41569,
    rx: 0.503993,
    stroke: "#914DE5",
    strokeWidth: 0.815835
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5173,
    y: 9.50167,
    width: 4.41548,
    height: 4.41569,
    rx: 0.503993,
    stroke: "#914DE5",
    strokeWidth: 0.815835
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5173,
    y: 19.344,
    width: 4.41548,
    height: 4.41569,
    rx: 0.503993,
    stroke: "#914DE5",
    strokeWidth: 0.815835
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0137 11.5898H18.336",
    stroke: "#914DE5",
    strokeWidth: 0.815835,
    strokeLinecap: "round",
    strokeDasharray: "1.63 1.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0137 21.5518H18.336",
    stroke: "#914DE5",
    strokeWidth: 0.815835,
    strokeLinecap: "round",
    strokeDasharray: "1.63 1.63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7266 14.8154L21.7266 18.1377",
    stroke: "#914DE5",
    strokeWidth: 0.815835,
    strokeLinecap: "round",
    strokeDasharray: "1.63 1.63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9141 14.8154L11.9141 18.1377",
    stroke: "#914DE5",
    strokeWidth: 0.815835,
    strokeLinecap: "round",
    strokeDasharray: "1.63 1.63"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBar3);
export default __webpack_public_path__ + "static/media/sideBar3.823d95960cab780449719f6995c0fd4a.svg";
export { ForwardRef as ReactComponent };